import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

export const useIntegrations = (page = 1, limit = 100, search = "") => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["integrations", page, limit, search],
    () => fetchData(`/integrations?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        integrations: response?.data || [],
        pagination: response?.pagination || { total: 0 },
      }),
    }
  );

  const updateMutation = useMutation(
    (integration) => {
      const method = integration?.id ? "PUT" : "POST";
      const endpoint = integration?.id ? `/integrations/${integration.id}` : `/integrations`;
      return fetchData(endpoint, method, integration);
    },
    { onSuccess: () => queryClient.invalidateQueries("integrations") }
  );

  const deleteMutation = useMutation(
    (id) => fetchData(`/integrations/${id}`, "DELETE"),
    { onSuccess: () => queryClient.invalidateQueries("integrations") }
  );

  const testMutation = useMutation(
    (id) => fetchData(`/integrations/${id}/test`, "POST"),
    { onSuccess: () => queryClient.invalidateQueries("integrations") }
  );

  return { ...query, updateMutation, deleteMutation, testMutation };
};
